import { DocumentPartMap } from './../index'

export class AttributeMaps {
    public AttributeId: number;
    public Maps: DocumentPartMap[] = [];
}
